import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { styled } from 'styled-components';
import { Input } from './index.js';
const CustomInput = (props) => {
    return (React.createElement(Input, { value: (props.selected && props.selected.calendar()) || '', ...props }));
};
const DateInput = (props) => {
    return (React.createElement(StyledDatePicker, { customInput: React.createElement(CustomInput, { success: !!props.value, style: props.style, disabled: props.disabled }), placeholderText: props.placeholder, dateFormat: props.customDateFormat
            ? props.customDateFormat
            : [
                `dd.MM.yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `dd.MM.yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `dd/MM/yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `dd-MM-yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `ddMMyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `dd/MM/yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `dd-MM-yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                `ddMMyyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
            ], selected: props.value && props.value.toDate(), onChange: (date) => {
            if (props.onChange) {
                if (props.allowNull) {
                    props.onChange(date != null ? moment(date) : null);
                }
                else if (date != null) {
                    props.onChange(moment(date));
                }
            }
        }, maxDate: props.maxDate, minDate: props.minDate, showTimeSelect: props.showTimeSelect, timeFormat: props.showTimeSelect ? 'HH:mm' : undefined, timeIntervals: props.showTimeSelect ? 1 : undefined, strictParsing: true, disabled: props.disabled }));
};
export default DateInput;
// @ts-expect-error
const StyledDatePicker = styled(DatePicker) `
  &,
  .react-datepicker__input-container,
  .react-datepicker__input-container {
    display: block;
  }
`;
//# sourceMappingURL=DateInput.js.map